import React from 'react'
import _ from 'lodash'
import { InputText } from 'primereact/inputtext'

export default function LtsCamposComplementares(props) {
  const onChange = (campo, event) => {
    const dadosComplementares = _.get(props.record, `dadosComplementares`, {})
    dadosComplementares[campo] = event.target.value
    props.setField(dadosComplementares)
  }

  const resolveValue = (nomeCampo) => {
    let value = _.get(props.record, `dadosComplementares.${nomeCampo}`)
    if (_.isEmpty(value)) {
      value = props.camposComplementares[nomeCampo].default || null
    }
    return value
  }

  return (
    <React.Fragment>
      <div className="p-grid form-group">
        {Object.keys(props.camposComplementares).map((nomeCampo) => (
          <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
            <span className="p-float-label">
              <InputText
                value={resolveValue(nomeCampo)}
                onChange={(e) => onChange(nomeCampo, e)}
                name={nomeCampo}
                className={'width-25-rem'}
              />
              <label>{props.camposComplementares[nomeCampo].label}</label>
            </span>
          </div>
        ))}
      </div>
    </React.Fragment>
  )
}
